
 function Card({step, title, text}: {step: string, title: string, text: string}) {
  return (
    <div className=" p-2 bg-gray-400/30 border rounded-lg drop-shadow-lg sm:p-2 md:p-4">
        <span className="sm:text-lg md:text-xl font-bold text-green-600">Step {step}</span>
        <h1 className="text-md sm:text-lg md:text-2xl font-bold text-white">{title}</h1>
        <span className=" text-sm sm:text-base text-neutral-100 font-semibold">{text}</span>
    </div>
  )
}

export default Card
